import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Box, Heading, Text, Link } from '@chakra-ui/react';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";
import BackgroundWrapper from 'components/Background/Background';

const SignupConfirmation = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');

  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (token) {
      api
        .get(`${API_BASE}/api/auth/user-confirmation?token=${token}`)
        .then((res) => {
          if (res.status == 200) {
            setConfirmed(true);
          }
        })
        .catch(() => console.log('failed to verify email, token: ', token));
    }
  }, [token]);

  return (
    <BackgroundWrapper applyMd={true}>
      <Box
        bg="white"
        p={8}
        boxShadow="lg"
        borderRadius="lg"
        width="400px"
        maxWidth="90%"
        mx="auto"
        my={12}
      >
        {confirmed ? (
          <>
            <Heading as="h2" size="xl" mb={4} textAlign="center">
              Signup Confirmation!
            </Heading>
            <Text fontSize="lg" textAlign="center" mb={6}>
              Your email has been verified, you can{' '}
              <Link
                as={RouterLink}
                to="/signin"
                color="blue.500"
                fontWeight="bold"
              >
                sign in
              </Link>{' '}
              using your new credentials.
            </Text>
          </>
        ) : (
          <>
            <Heading as="h2" size="xl" mb={4} textAlign="center">
              Almost Done!
            </Heading>
            <Text fontSize="lg" textAlign="center" mb={6}>
              Please check your email and verify your account.
              <br />
              Once verified, you can{' '}
              <Link
                as={RouterLink}
                to="/signin"
                color="blue.500"
                fontWeight="bold"
              >
                sign in
              </Link>{' '}
              using your new credentials.
            </Text>
          </>
        )}
      </Box>
    </BackgroundWrapper>
  );
};

export default SignupConfirmation;
